/**
 * Org Payment Accounts Add-button cap must use the unfiltered account total.
 * Search/pill filters shrink `recordCount`/`rowCount`; those must not re-enable Add
 * while the org is still at the hard limit (backend enforces the same cap).
 */
export function nextUnfilteredPaymentAccountCount(
  previousUnfilteredCount: number,
  currentRowCount: number,
  hasActiveListFilter: boolean,
): number {
  return hasActiveListFilter ? previousUnfilteredCount : currentRowCount;
}

export function isAtPaymentAccountLimit(
  unfilteredCount: number,
  limit: number,
): boolean {
  return unfilteredCount >= limit;
}
